export enum ZIndex {
  programPopupZIndex = 1,
  popupZIndex = 2,
}
